module.exports = __webpack_public_path__ + "static/media/stripe.aa8325b7.png";